<template>
  <v-container fluid>
   
      <v-data-table
        :headers="headers"
        :items="users"
        :loading="tableLoading"
        :search="search"
        :items-per-page="1000"
        :sort-by="['name']"
        :sort-desc="[true]"
        item-key="name"
        class="elevation-1"
      >
      <template v-slot:top>
         <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        class="mx-4"
      ></v-text-field>
        </template>
       <template v-slot:item.pbn_access="{ item }" >

           <v-switch
                v-model="item.pbn_access"
                @click="updatePermissions(item.id,item.pbn_access)"
                ></v-switch>
        </template>

      </v-data-table>       

  <v-snackbar
      v-model="snackbar"
      :timeout="360"
      :value="true"
      color="blue"
      absolute
      center
      rounded="pill"
      top
    >
    {{ snackbarMsg }}
  </v-snackbar>

  </v-container>
</template>

<style>
canvas {
  width: 100% !important;
  height: 600px !important;
}

tbody tr:nth-child(odd) {
  background-color: rgba(0, 0, 0, 0.05);
}

</style>

<script>
export default {
  data: function() {
    return {
      users: [],
      tableLoading: true,
      search: "",
      snackbar: false,
      snackbarMsg: "",
      headers: [
        {
          text: "User",
          sortable: true,
          value: "name",
        },     
        { text: "PBN Access", value: "pbn_access" },
    
      ],
    
    };
  },

  created: function() {
  
    this.$store
      .dispatch("getUsers")
      .then(async (response) => {
          this.users = response.data
    
          this.tableLoading = false
      })
    },
    methods: {
         updatePermissions (userid, current_value){
                this.$store
                    .dispatch("updatePbnPermissions", {user_id: userid, current_value: current_value})
                    .then(async (response) => {
                    
                        this.snackbarMsg = response.data
                        this.snackbar = true
                    }).catch( (e) => {
                      this.snackbarMsg = e.response.data
                      this.snackbar = true
                    })
        }

    }

  }

</script>
